define('editor/edit/map/index',['durandal/app', 'plugins/http', './controls/coordinator', 'plugins/router', './mapstate', './configHelpers', 'leaflet-tile-nogap'], function (app, http, controlsCoordinator, router, mapState, configHelper) {
    var viewmodel = function () {
        var self = this;
        self.router = router;
        self.defaultMapState = {
            "zoom": 2,
            "center": {
                "lat": 16.63,
                "lon": -7.73
            },
            "tileLayer": "Road"
        };

        self.activate = function (editorMap, isRenderMode) {
            self.editorMap = editorMap;
            self.isRenderMode = isRenderMode;
        };

        self.detached = function () {
            // give any child module outside of the durandal lifecycle a chance to de-register their event listeners
            self.coordinator.destroy();
        };

        self.compositionComplete = function () {
            // map must be inited after view is attached and container exists in DOM
            if ($('#mapbox-map').length === 0) {
                return;
            }
            self.initialiseMap();
            self.initialiseControls();
            self.registerEventHandlers();
            app.trigger("map:ready");
            self.tempMarkers = new L.LayerGroup();
            self.tempMarkers.addTo(self.mapControl);
        };

        self.registerEventHandlers = function () {
            self.mapControl.on("zoomend", self.onMapZoomEnd);
            self.mapControl.on("moveend", self.onMapMoveEnd);
            self.mapControl.on("map:tiles:updated", self.onMapTilesSwitched);
            app.on('map:clicks:listen', function () {
                self.mapControl.getContainer().className = self.mapControl.getContainer().className + " leaflet-targeting";
                self.mapControl.on('click', function (e) {
                    app.trigger('map:click', e);
                });
            });

            app.on('map:clicks:ignore', function () {
                var classes = self.mapControl.getContainer().className.split(' '),
                    indexOfTarget = classes.indexOf('leaflet-targeting'),
                    newClassNames;

                classes.splice(indexOfTarget, 1); // reset cursor
                newClassNames = classes.join(' ');

                self.mapControl.getContainer().className = newClassNames;
                self.mapControl.off('click');
            });

            app.on('directions:waypoint:set', function (location) {
                self.tempMarkers.addLayer(L.marker([location.latLng.lat, location.latLng.lng]).bindPopup(location.displayName));
            });

            app.on('directions:route:new', function () {
                self.tempMarkers.clearLayers();
            });

            app.on('map:settings:updated', function (newSettings) {
                self.emptyLabelsTileLayer();

                self.addLabelsTileLayer(newSettings.useLabelsLayer);
            });

            app.on('map:boundaries:preview', function (boundaries, keepLayers) {
                self.showTempBoundaries(boundaries, keepLayers);
            });

            app.on('map:boundaries:clear', function () {
                self.showTempBoundariesFeatureGroup.clearLayers();
            });
        };

        self.initialiseMap = function () {
            // Object.keys is ES5
            if (!Object.keys(self.editorMap.state).length) {
                self.editorMap.state = self.defaultMapState;
                self.saveMapControlState();
            }

            var disableFractionalZoom = self.router.activeInstruction().params.length > 1 && typeof (self.router.activeInstruction().params[1].disablefractionalzoom) !== 'undefined';
            var mapOptions = {
                minZoom: 1,
                maxZoom: 17,
                zoomSnap: disableFractionalZoom ? 1 : 0.1,
                zoomDelta: disableFractionalZoom ? 1 : 0.1
                // ,wheelPxPerZoomLevel: 50 // default, change to affect zoom level from mouse wheel
            };

            if (self.isRenderMode) {
                mapOptions.attributionControl = false;
                mapOptions.infoControl = false;
                mapOptions.zoomControl = false;
                mapOptions.scrollWheelZoom = false;
                mapOptions.dragging = false;
            }
            // check if using mapbox
            if (self.editorMap.mapboxApiKey.length) {
                L.mapbox.accessToken = self.editorMap.mapboxApiKey;
            }

            self.baseLayers = self.editorMap.tileLayers;

            var layerLen = self.baseLayers.length,
                activeLayer = self.baseLayers[0];

            for (var i = 0; i < layerLen; i++) {
                var tiles = self.baseLayers[i];
                var tileLayerProps = configHelper.mapEditorMapConfigToLeafletTilelayerProps(self.editorMap, tiles);

                tiles['layer'] = new L.TileLayer.NoGap(tileLayerProps.tileLayerUrlTemplate, tileLayerProps.tileLayerOptions);

                if (tiles.name === self.editorMap.state.tileLayer) {
                    tiles['active'] = true;
                    activeLayer = tiles;
                } else {
                    tiles['active'] = false;
                }
            }

            self.mapControl = L.map('mapbox-map', mapOptions);
            self.mapControl.addLayer(activeLayer.layer);
            self.mapControl.setView([self.editorMap.state.center.lat, self.editorMap.state.center.lon], self.editorMap.state.zoom);

            if (self.editorMap.labelsLayer) {
                self.addLabelsTileLayer(self.editorMap.useLabelsLayer);
            }

            self.showTempBoundariesFeatureGroup = L.featureGroup();
            self.showTempBoundariesFeatureGroup.addTo(self.mapControl);

            app.map = new mapState(self.mapControl);

            self.mapControl.on('moveend', function () {
                app.trigger('map:moveend');
            });
        };

        self.showTempBoundaries = function (boundaries, keepLayers) {
            if (!keepLayers) {
                self.showTempBoundariesFeatureGroup.clearLayers();
            }

            if (!boundaries) {
                return;
            }

            for (var i = 0; i < boundaries.length; i++) {
                var boundary = boundaries[i];
                var geoJson = L.geoJson(boundary.geojson);
                geoJson.properties = { id: boundary.boundaryId };
                geoJson.addTo(self.showTempBoundariesFeatureGroup);
            }
        };

        self.addLabelsTileLayer = function (putAboveShapes) {
            // gets a z-index of 5 in css (class name becomes 'leaflet-mapforge-tiles-pane') 
            // putting it above other tiles (4), on same as shadows, underneath everything else like markers (6)
            var tileLayerProps = configHelper.mapEditorMapConfigToLeafletTilelayerProps(self.editorMap, self.editorMap.labelsLayer);

            if (putAboveShapes) {
                var paneName = 'mapforge-tiles';

                self.mapControl.createPane(paneName);

                tileLayerProps.tileLayerOptions.pane = paneName;
            }

            L.tileLayer(tileLayerProps.tileLayerUrlTemplate, tileLayerProps.tileLayerOptions).addTo(self.mapControl);
        };

        self.emptyLabelsTileLayer = function () {
            $('.leaflet-mapforge-tiles-pane').remove();
        };

        self.initialiseControls = function () {
            self.coordinator = new controlsCoordinator(self.editorMap, self.mapControl, self.isRenderMode, self.baseLayers);

            self.coordinator.initialise();
        };

        // map events
        self.onMapTilesSwitched = function (e) {
            var tileLayer = e.name;

            self.editorMap.state.tileLayer = tileLayer;

            self.saveMapControlState();
        };

        self.onMapZoomEnd = function (ev) {
            var newZoom = ev.target._zoom;

            self.editorMap.state.zoom = newZoom;

            self.saveMapControlState();
        };

        self.onMapMoveEnd = function () {
            var newCenter = self.mapControl.getCenter();

            self.editorMap.state.center.lat = newCenter.lat;
            self.editorMap.state.center.lon = newCenter.lng;

            self.saveMapControlState();
        };

        self.saveMapControlState = function () {
            var data = {
                editorMapId: self.editorMap.id,
                newState: self.editorMap.state
            };
            return http.post("/api/editor/state", data);
        };


        self.getVisibleMapBounds = function () {
            return self.coordinator.getBoundingBox();
        };
    };

    return viewmodel;

});

